<template>
	<v-dialog v-model="isVisible" max-width="700">
		<p-card class="skill-selection">
			<span
				class="tw-p-2 tw-w-full tw-text-center text-lg tw-text-white skill-title tw-block tw-mb-4"
				>Escoge 3 Verbos ({{ jobsSelect.length }} / 3)</span
			>
			<c-job-verbs-selector
				v-if="verbsSelection && selectedJob"
				v-show="currentPage === 1"
				:verbs-info="this.verbsSelection"
				:selected-job="selectedJob"
				@selectedJobDataChanged="verbJobSelected"
			/>
			<div class="tw-text-center tw-pt-6">
				<p-button type="black" @click="close()">Cerrar</p-button>
				<p-button
					:disabled="!jobsSelect.length || jobsSelect.length > 3 || jobsSelect.length < 3"
					type="secondary"
					@click="handleSave()"
					>Guardar</p-button
				>
			</div>
		</p-card>
	</v-dialog>
</template>
<script>
import PButton from '@/modules/shared/components/ui/p-button';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import cJobVerbsSelector from '@/modules/job-profile/components/first-step/c-job-verbs-selector';
import { mapState } from 'vuex';
import { path } from 'ramda';

function created() {
}

function verbJobSelected(infoSelected) {
	this.jobsSelect = infoSelected;
}

function handleSave() {
	this.$emit('onSave', this.jobsSelect);
	this.close();
}

export default {
	name: 'verbs-selection-dialog',
	components: {
		PCard,
		PButton,
		cJobVerbsSelector,
	},
	beforeCreate() {
		this.$store.dispatch('jobEvaluation/loadVerbs');
	},
	created,
	data() {
		return {
			isVisible: false,
			jobsSelect: [],
			currentPage: 1,
		};
	},
	props: {
		selectedJob: {
			default: () => ({}),
		},
		// verbsInfo: {
		// 	default: () => ({}),
		// },
	},
	methods: {
		handleSave,
		verbJobSelected,
		open() {
			this.checkBoxModel = {};
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
	},
	computed: {
		...mapState('jobEvaluation', {
			verbsSelection: path(['supplies', 'guidelineModel', 'verbsSelection']),
		}),
	},
	watch: {
		verbsSelection: {
			handler(newVal) {
				this.verbsSelection = newVal;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.skill-selection {
	p {
		color: var(--app-color-font-gray);
	}
	.skill-title {
		background-color: var(--app-color-primary);
		border-radius: 5px;
	}
	.skill-table {
		height: 40vh;
		overflow: auto;
		&--row {
			display: flex;
			border-top: 0.5px solid var(--app-color-gray);
			border-bottom: 0.5px solid var(--app-color-gray);
			padding: 10px 0 10px;
			& > :nth-child(1) {
				text-align: center;
				width: 10%;
			}
			& > :nth-child(2) {
				width: 30%;
			}
			& > :nth-child(3) {
				width: 60%;
			}

			// overriding custom checkbox style
			.custom-checkbox {
				margin: 0 !important;
				display: flex !important;
				justify-content: center !important;
				padding: 0 !important;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/first-step/verbs-selection-dialog.vue